import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'common/components';

import Validated from 'components/util/Validated';
import AuthSchemas from 'schemas/auth_schemas';

const RecoverPasswordForm = ({
  values = { email: '' },
  handleValueChange,
  handleSubmit,
  errors = {},
  isSubmitted = false,
  isLoading = false,
  t = (arg) => arg,
}) => {
  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row">
        <div className="col-12">
          <Form.FieldInput
            value={values.email}
            name="email"
            placeholder={t('recover_password.fields.email')}
            error={(isSubmitted && errors.email) || {}}
            errorPrefix={'recover_password.email'}
            handleChange={handleValueChange}
            inputSize={'lg'}
            iconLeft={'envelope'}
            iconRightSize={'lg'}
            autoFocus={true}
          />
        </div>

        <div className="col-md-12">
          <Form.Button
            text={t('recover_password.fields.submit')}
            isLoading={isLoading}
            extraClassName={'btn-lg pull-right btn-md-block'}
          />

          <Form.Link to={'/auth/login'} className="btn btn-lg btn-link pull-right btn-md-block">
            {t('recover_password.fields.login')}
          </Form.Link>
        </div>
      </div>
    </form>
  );
};

RecoverPasswordForm.propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
  handleValueChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object,
  isSubmitted: PropTypes.bool,
  isLoading: PropTypes.bool,
  t: PropTypes.func,
};

export default Validated(AuthSchemas.recover_password)(RecoverPasswordForm);



// WEBPACK FOOTER //
// src/modules/auth/components/form/RecoverPasswordForm.js